import { ActionTree } from "vuex";
import { InvitationState } from ".";
import { RootState } from "..";
import invitationApi from "../../api/invitation.api";
import i18n from "../../i18n";
import { InvitationAcception } from "../../models";
import { RootActionTypes } from "../root-actions";
import { ToastMessage } from "./../../models/toast-message.model";
import { RootMutationTypes } from "./../root-mutations";
import * as Sentry from "@/utils/logger.util";

export const InvitationActionTypes = {
  AcceptInvitation: "ACCEPT_INVITATION"
};

export const actions: ActionTree<InvitationState, RootState> = {
  async [InvitationActionTypes.AcceptInvitation]({ commit, dispatch }, payload: InvitationAcception) {
    try {
      await invitationApi.postAcceptInvitation(payload);
      commit(
        RootMutationTypes.SetToastMessages,
        {
          variant: "success",
          title: i18n.tc("alert.title.success"),
          content: i18n.tc("accept_invitation.accept_success")
        } as ToastMessage,
        { root: true }
      );
    } catch (error) {
      Sentry.captureException(error);
      dispatch(RootActionTypes.HandleApiError, error, { root: true });
    }
  }
};
